var _path, _path2, _mask, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15658 1.22869C0.985623 1.42077 0.879152 1.71788 0.879152 2.11643V17.7828C0.879152 18.1801 0.984924 18.4765 1.15489 18.6687L10.0457 10.0036V9.89214L1.15658 1.22869Z",
    fill: "white",
    stroke: "#41BCC4",
    strokeWidth: 0.181643
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1791 7.05864L10.2727 9.89236V10.0039L13.1768 12.8388L16.7277 10.8725C17.215 10.602 17.4301 10.2623 17.4301 9.94854C17.4301 9.63491 17.2151 9.29613 16.7279 9.0274L16.7277 9.02726L13.1791 7.05864Z",
    fill: "white",
    stroke: "#41BCC4",
    strokeWidth: 0.181643
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_187_253",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2281 12.9404L10.1592 9.94823L1.10254 18.7794C1.43949 19.1247 1.98895 19.1664 2.6138 18.821L13.2281 12.9404Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2281 12.9404L10.1592 9.94823L1.10254 18.7794C1.43949 19.1247 1.98895 19.1664 2.6138 18.821L13.2281 12.9404Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1592 9.94823L10.0007 9.78566L10.1592 9.63111L10.3177 9.78566L10.1592 9.94823ZM1.10254 18.7794L0.940024 18.938L0.781415 18.7754L0.944025 18.6168L1.10254 18.7794ZM2.6138 18.821L2.72384 19.0196L2.72364 19.0197L2.6138 18.821ZM13.0696 13.1029L10.0007 10.1108L10.3177 9.78566L13.3866 12.7778L13.0696 13.1029ZM10.3177 10.1108L1.26105 18.942L0.944025 18.6168L10.0007 9.78566L10.3177 10.1108ZM1.26505 18.6208C1.50444 18.8662 1.93088 18.939 2.50397 18.6223L2.72364 19.0197C2.04703 19.3937 1.37454 19.3833 0.940024 18.938L1.26505 18.6208ZM2.50377 18.6224L13.118 12.7417L13.3381 13.139L2.72384 19.0196L2.50377 18.6224Z",
    fill: "#41BCC4",
    mask: "url(#path-3-inside-1_187_253)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1592 9.78982L13.0395 6.98154L2.55932 1.17518C2.55923 1.17513 2.55913 1.17508 2.55904 1.17502C2.01544 0.877756 1.56324 0.897333 1.26882 1.12429L10.1592 9.78982Z",
    fill: "white",
    stroke: "#41BCC4",
    strokeWidth: 0.181643
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayWhite);
export default __webpack_public_path__ + "static/media/google-play-white.9f610efbdff11879d03105b1d1090cb0.svg";
export { ForwardRef as ReactComponent };